module.exports = __webpack_public_path__ + "static/media/Avenir-HeavyOblique.bd62ce88.ttf";